export const groupChecklistItemsByCategory = (checklistItems, categoriesMap, categoriesError, useChecklistStyle) => {
  const itemsByCategory = {};

  checklistItems.forEach(item => {
    const categoryId = item.categoryId;
    const category = categoriesMap[categoryId] || categoriesMap[String(categoryId)];
    const categoryTitle = category?.title || `Category ${categoryId}`;

    if (!itemsByCategory[categoryId]) {
      itemsByCategory[categoryId] = {
        id: categoryId,
        title: categoryTitle,
        items: []
      };
    }

    itemsByCategory[categoryId].items.push({
      ...item,
      ...(useChecklistStyle
        ? { checked: false, notes: '' }
        : { status: 'pass', notes: '' }),
    });
  });

  return Object.values(itemsByCategory)
    .map(category => ({
      ...category,
      items: category.items.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    }))
    .sort((a, b) => {
      const categoryA = categoriesMap[a.id];
      const categoryB = categoriesMap[b.id];
      return (categoryA?.sortOrder || 0) - (categoryB?.sortOrder || 0);
    });
};

export const buildCategoriesMap = (categoriesData, checklistItems, categoriesError) => {
  const categoriesMap = {};

  if (categoriesData?.checklistCategories) {
    categoriesData.checklistCategories.forEach(category => {
      categoriesMap[category.id] = category;
      categoriesMap[String(category.id)] = category;
    });
  } else if (categoriesError && checklistItems) {
    const uniqueCategoryIds = [...new Set(checklistItems.map(item => item.categoryId))];
    uniqueCategoryIds.forEach(categoryId => {
      const sampleItem = checklistItems.find(item => item.categoryId === categoryId);
      const fallbackCategory = {
        id: categoryId,
        title: sampleItem?.category?.title || `Category ${categoryId}`,
        color: sampleItem?.category?.color || '#E5E7EB',
        sortOrder: sampleItem?.category?.sortOrder || 0
      };
      categoriesMap[categoryId] = fallbackCategory;
      categoriesMap[String(categoryId)] = fallbackCategory;
    });
  }

  return categoriesMap;
};

export const countRequiredComplete = (groupedItems, useChecklistStyle) => {
  const allItems = groupedItems.flatMap(category => category.items);
  const requiredItems = allItems.filter(item => item.isRequired);
  if (requiredItems.length === 0) {
    return { completed: 0, total: 0 };
  }

  const completed = requiredItems.filter(item =>
    useChecklistStyle ? item.checked : item.status === 'pass'
  ).length;

  return { completed, total: requiredItems.length };
};

export const applyCompletionDataToItems = (groupedItems, completionData, targetChecklistId, useChecklistStyle = false) => {
  if (!completionData?.getJobChecklistCompletions || !targetChecklistId) {
    return groupedItems;
  }

  const relevantCompletion = completionData.getJobChecklistCompletions.find(
    completion => String(completion.checklistId) === String(targetChecklistId)
  );

  if (!relevantCompletion?.items) {
    return groupedItems;
  }

  const completionMap = {};
  relevantCompletion.items.forEach(itemCompletion => {
    const key = String(itemCompletion.itemId);
    completionMap[key] = {
      completed: itemCompletion.completed,
      status: itemCompletion.completed ? 'pass' : 'fail',
      notes: itemCompletion.notes || ''
    };
  });

  return groupedItems.map(category => ({
    ...category,
    items: category.items.map(item => {
      const completion = completionMap[String(item.id)];
      if (!completion) return item;

      if (useChecklistStyle) {
        return {
          ...item,
          checked: completion.completed,
          notes: completion.notes
        };
      }

      return {
        ...item,
        status: completion.status,
        notes: completion.notes
      };
    })
  }));
};
